<template>
  <div
    :class="[
      'game',
      'game-spell',
      (status !== undefined || showSolution) && 'game-finished',
    ]"
  >
    <Keypress
      key-event="keyup"
      @success="onKeyUp($event)"
      :prevent-default="false"
    />
    <h2>Spell</h2>
    <div v-if="selectedWord" :title="selectedWord[gameTargetLang]">
      <div :class="`word-src word-${gameSrcLang}`">
        {{ selectedWord[gameSrcLang] }}
      </div>
      <div :class="`word-target word-${gameTargetLang}`">
        <div
          v-for="(letter, index) in letters"
          :key="`spell-${gameTargetLang}-${index}`"
          :title="letter"
          :class="[
            letter !== ' ' ? 'letter' : 'blank',
            index === current && 'current',
            letter !== ' ' &&
              input[index] !== ' ' &&
              (letter === input[index] ? 'letter-ok' : 'letter-error'),
          ]"
          @click="onClick($event, index)"
        >
          {{ showSolution ? letter : input[index] }}
        </div>
      </div>
    </div>
    <IcelandicCharacters v-on:is-char-event="onIsChar" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IcelandicCharacters from "@/components/IcelandicCharacters.vue";
const constants = require("@/constants.js");

export default {
  name: "GameSpell",
  components: {
    IcelandicCharacters,
    Keypress: () => import("vue-keypress"),
  },
  data() {
    const emptyWord = {};
    emptyWord[this.gameSrcLang] = "";
    emptyWord[this.gameTargetLang] = "";
    return {
      emptyWord,
      current: 0,
      letters: [],
      input: [],
      status: undefined,
      showSolution: false,
      errors: 0,
    };
  },
  computed: {
    ...mapGetters([
      "gameSrcLang",
      "gameTargetLang",
      "gameAllowedErrors",
      "selectedWords",
    ]),
    selectedWord: function () {
      if (this.selectedWords.length == 0) return this.emptyWord;
      for (let word of this.selectedWords) {
        if (word.failed) return word;
      }
      return this.selectedWords[0];
    },
  },
  mounted() {
    // console.log(
    //   `mounted ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.initGame();
  },
  created() {
    // console.log(
    //   `created ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.$store.subscribe((mutation, state) => {
      if (["CATEGORY_SELECTED", "NEW_GAME"].includes(mutation.type)) {
        this.initGame();
      }
    });
  },
  methods: {
    onClick(e, index) {
      console.log("onClick");
    },
    onKeyPress(e) {
      //
      // TODO https://github.com/lupas/vue-keypress
      //
      if (e) {
        console.log(`onKeyPress charCode: ${e.charCode} key: ${e.key}`);
      }
    },
    onKeyUp(e) {
      if (this.showSolution) return;

      if (e.event.altKey) return;
      //
      // TODO https://github.com/lupas/vue-keypress
      //
      // console.log(`onKeyUp keyCode: ${e.event.keyCode} key: ${e.event.key}`);
      // 37 left, 39 right
      if (e.event.keyCode == 37) {
        if (this.current > 0) {
          this.current--;
          if (this.letters[this.current] === " " && this.current > 0) {
            this.current--;
          }
        }
      } else if (e.event.keyCode == 39) {
        if (this.current < this.letters.length - 1) {
          this.current++;
          if (
            this.letters[this.current] === " " &&
            this.current < this.letters.length - 1
          ) {
            this.current++;
          }
        }
      } else {
        let ch = e.event.key.toLowerCase();
        if (
          constants.ALPHABET.includes(ch) ||
          constants.PUNCTUATIONS.includes(ch)
        ) {
          this.inputChar(ch);
        }
      }
    },
    onIsChar(ch) {
      this.inputChar(ch);
    },
    inputChar(ch) {
      if (this.showSolution) return;

      this.input[this.current] = ch;
      this.input = this.input.slice(0);

      if (this.current < this.letters.length - 1) {
        if (this.letters[this.current] === this.input[this.current]) {
          this.current++;
          if (
            this.letters[this.current] === " " &&
            this.current < this.letters.length - 1
          ) {
            this.current++;
          }
        }
      }

      let same = true;
      let filled = 0;
      for (let ii = 0; ii < this.letters.length; ii++) {
        if (
          this.letters[ii] === " " ||
          (this.letters[ii] !== " " && this.input[ii] !== " ")
        ) {
          filled++;
        }
        if (this.letters[ii] !== this.input[ii]) {
          same = false;
        }
      }
      if (filled == this.letters.length) {
        this.setGameStatus(same);
      } else {
        this.setGameStatus(undefined);
      }
    },
    initGame() {
      console.log(
        `GameSpell initGame ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}: ${this.selectedWord[this.gameTargetLang]}`
      );

      this.showSolution = false;
      this.current = 0;
      this.letters = [];
      this.input = [];
      for (const ch of this.selectedWord[this.gameTargetLang]) {
        this.letters.push(ch);
        if (constants.ALPHABET.includes(ch)) {
          this.input.push(" ");
        } else {
          this.input.push(ch);
        }
      }
      this.setGameStatus(undefined);
      this.errors = 0;
    },
    setGameStatus(status) {
      if (status === false) {
        this.errors++;
        if (this.errors < this.gameAllowedErrors) return;
      }
      this.status = status;
      this.$emit("gameStatus", this.status);
    },
    solution() {
      this.showSolution = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";

.word-src {
  font-style: italic;
}

.word-target {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
@keyframes blink {
  50% {
    border-bottom-color: transparent;
  }
}
.letter {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  height: 2.5rem;
  width: 1.5rem;
  line-height: 2rem;
  border-bottom: 6px solid #555;

  &.current {
    animation: blink 0.5s step-end infinite alternate;
  }
}
.game-finished .letter {
  border-bottom-color: orange;
}
.game.status-ok .letter.current {
  animation: none;
}
.letter-ok {
  border-bottom-color: green;
}
.letter-error {
  border-bottom-color: red;
}
.blank {
  width: 1rem;
}
</style>
